// extracted by mini-css-extract-plugin
module.exports = {"infoList":"_1rrAnmKnqYqESQl2U4NtXW"};